import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css

var utility = (function () {

    var showConfirm = function (config) {
        const options = {
            // title: 'Title',
            message: (config && config.message) ? config.message : 'Are you sure you want to delete?',
            buttons: [
                {
                    label: (config && config.yes) ? config.yes : 'Yes',
                    onClick: () => {
                        if (config && config.onYesClick) {
                            config.onYesClick();
                        }
                    }
                },
                {
                    label: (config && config.no) ? config.no : 'No',
                    onClick: () => {
                        if (config && config.onNoClick) {
                            config.onNoClick();
                        }
                    }
                }
            ]
        }

        confirmAlert(options)
    }
    var showAlert = function (message) {
        const options = {
            message: message,
            buttons: [
                {
                    label: 'Ok',
                    onClick: null
                }
            ]
        }

        confirmAlert(options)
    }
    return {
        showConfirm: showConfirm,
        showAlert: showAlert,
    }

})();

export default utility;